import { AfterViewInit, Component, inject } from '@angular/core';
import { ReturnWarrantyTableComponent } from 'gung-standard';
import { TyloOrderServicesService } from '../../services/tylo-order-services.service';

@Component({
  selector: 'tylo-return-warranty-table',
  standalone: false,
  templateUrl: './tylo-return-warranty-table.component.html',
  styleUrl: './tylo-return-warranty-table.component.css'
})
export class TyloReturnWarrantyTableComponent extends ReturnWarrantyTableComponent implements AfterViewInit {
  protected orderServicesService = inject(TyloOrderServicesService);

  statusColor: { [s: string]: string } = {
    'REGISTERED': '#ffdc73ff', // Yellow
    'WAITING_INFO_FROM_CUSTOMER': '#f7a66cff', // Orange
    'ADDITIONAL_INFO_PROVIDED': '#5c85b3ff', // Blue
    'REJECTED': '#bb4b4bff', // Red
    'APPROVED': '#6fb96fff' // Green
  }

  public claimStatusColor(status: string) {
    return this.statusColor?.[status];
  }
}
